import { sourceContext } from 'aurelia-binding';
var AsyncDirtyBindingBehavior = /** @class */ (function () {
    function AsyncDirtyBindingBehavior() {
    }
    AsyncDirtyBindingBehavior.prototype.bind = function (binding, source, busymessage, frequency) {
        if (frequency === void 0) { frequency = 500; }
        if (!binding.updateTarget) {
            throw new Error("Only property bindings and string interpolation bindings can be dirty checked.  Trigger, delegate and call bindings cannot be dirty checked.");
        }
        if (frequency) {
            binding.dirtyTimer = setInterval(function (t) { return binding.call(sourceContext); }, frequency);
        }
        binding.originalupdateTarget = binding.updateTarget;
        binding.updateTarget = function (a) {
            if (typeof a.then === "function") {
                if (busymessage) {
                    binding.originalupdateTarget(busymessage);
                }
                a.then(function (d) {
                    if (binding.originalupdateTarget && typeof binding.originalupdateTarget == "function") {
                        binding.originalupdateTarget(d);
                    }
                });
            }
            else {
                if (binding.originalupdateTarget && typeof binding.originalupdateTarget == "function") {
                    binding.originalupdateTarget(a);
                }
            }
        };
    };
    AsyncDirtyBindingBehavior.prototype.unbind = function (binding) {
        binding.updateTarget = binding.originalupdateTarget;
        binding.originalupdateTarget = null;
        if (binding.dirtyTimer) {
            clearInterval(binding.dirtyTimer);
        }
    };
    return AsyncDirtyBindingBehavior;
}());
export { AsyncDirtyBindingBehavior };
